import { Component, Vue } from 'vue-property-decorator'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faTrashAlt,
	faArrowUp,
	faArrowDown,
	faPeopleRoof,
	faHandHoldingDollar,
	faPersonCane,
	faCity,
	faChessKnight,
	faMoneyBillTransfer,
	faFeatherPointed,
} from '@fortawesome/free-solid-svg-icons'

import { Validations } from 'vuelidate-property-decorators'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

import ModalSubjectDependency from './ModalSubjectDependency/index.vue'
import Control from '@/helpers/control'
import api from '@/helpers/fetch'

library.add(
	faTrashAlt,
	faArrowUp,
	faArrowDown,
	faPeopleRoof,
	faHandHoldingDollar,
	faPersonCane,
	faCity,
	faChessKnight,
	faMoneyBillTransfer,
	faFeatherPointed,
)

@Component({
	components: {
		ModalSubjectDependency,
	},
	mixins: [validationMixin],
})
export default class SubjectOperationalModal extends Vue {
	subjectOperationalSuccess = false
	savingSubjectOperational = false
	nameSubjectOperational = ''
	control = new Control()
	groupsSubjects = [] as Array<any>
	subjectsOperational = [] as Array<any>
	selectedSubject = 0

	async mounted() {
		await this.loadGroupsSubjects()
	}

	async loadGroupsSubjects() {
		try {
			const res = await api.get('/api/groupsSubjects')
			const icons = [
				'people-roof',
				'hand-holding-dollar',
				'person-cane',
				'city',
				'chess-knight',
				'feather-pointed',
			]
			this.groupsSubjects = res.data.groupsSubjects.map(
				(group, index) => ({
					...group,
					icon: icons[index] || '',
				}),
			)
		} catch (error) {
			console.error('Error loading groupsSubjects:', error)
		}
	}

	clearSubjectOperational() {
		this.subjectOperationalSuccess = false
		this.nameSubjectOperational = ''
	}

	addNewSubjectOperational(subjectName, groupSubjectId) {
		this.subjectOperationalSuccess = false
		const debouncedChange = this.control.debounce(() => {
			this.saveSubjectOperational(null, subjectName, groupSubjectId)
		}, 2000)
		debouncedChange()
	}

	onInputSubjectOperational(subjectId: number, subjectName: string) {
		const debouncedChange = this.control.debounce(() => {
			this.saveSubjectOperational(subjectId, subjectName, null)
		}, 2000)
		debouncedChange()
	}

	@Validations()
	validations() {
		return {
			subjectsOperational: {
				$each: {
					name: {
						required,
					},
				},
			},
		}
	}

	async saveSubjectOperational(subjectId, subjectName, groupSubjectId) {
		if (!subjectName) {
			this.showToast("O campo 'nome' é obrigatório!", 'warning')
		} else {
			this.savingSubjectOperational = true
			this.subjectOperationalSuccess = false
			if (subjectId) {
				const res = await api.put('/api/subjects/', {
					id: subjectId,
					name: subjectName,
				})
				if (res.ok) {
					this.savingSubjectOperational = false
					this.subjectOperationalSuccess = true
					this.loadGroupsSubjects()
					this.showToast('Tese salva com sucesso!', 'success')
				} else {
					this.savingSubjectOperational = false
					this.showToast('Ocorreu um erro inesperado!', 'danger')
				}
			} else {
				this.savingSubjectOperational = true
				const res = await api.post('/api/subjects/', {
					name: subjectName,
					group_id: groupSubjectId,
				})
				if (res.ok) {
					this.savingSubjectOperational = false
					this.subjectOperationalSuccess = true
					this.nameSubjectOperational = ''
					this.loadGroupsSubjects()
					this.showToast('Tese salva com sucesso!', 'success')
				} else {
					this.savingSubjectOperational = false
					this.showToast('Ocorreu um erro inesperado!', 'danger')
				}
			}
		}
	}

	async moveUp(relations, relationIndex) {
		if (relationIndex > 0) {
			const temp = relations[relationIndex]
			Vue.set(relations, relationIndex, relations[relationIndex - 1])
			Vue.set(relations, relationIndex - 1, temp)

			// Troca a ordem dos itens localmente
			const tempOrder = relations[relationIndex].subject.order
			Vue.set(
				relations[relationIndex].subject,
				'order',
				relations[relationIndex - 1].subject.order,
			)
			Vue.set(relations[relationIndex - 1].subject, 'order', tempOrder)

			// Atualiza a ordem no servidor
			await this.updateOrder(relations)
		}
	}

	async moveDown(relations, relationIndex) {
		if (relationIndex < relations.length - 1) {
			const temp = relations[relationIndex]
			Vue.set(relations, relationIndex, relations[relationIndex + 1])
			Vue.set(relations, relationIndex + 1, temp)

			// Troca a ordem dos itens localmente
			const tempOrder = relations[relationIndex].subject.order
			Vue.set(
				relations[relationIndex].subject,
				'order',
				relations[relationIndex + 1].subject.order,
			)
			Vue.set(relations[relationIndex + 1].subject, 'order', tempOrder)

			// Atualiza a ordem no servidor
			await this.updateOrder(relations)
		}
	}

	async updateOrder(relations) {
		try {
			const updatedRelations = relations.map((relation) => ({
				id: relation.subject.id,
				order: relation.subject.order,
			}))

			await api.put('/api/subjects/updateOrder', updatedRelations)
		} catch (error) {
			console.error('Erro ao atualizar a ordem:', error)
		}
	}

	deleteSubjectOnClick(subject) {
		this.selectedSubject = subject
		this.$bvModal.show('modal-subject-dependency')
	}

	showToast(msg, variant) {
		this.$bvToast.toast(msg, {
			title:
				variant === 'success'
					? 'Sucesso!'
					: variant === 'danger'
						? 'Erro!'
						: 'Alerta!',
			autoHideDelay: 2500,
			appendToast: true,
			variant,
			toaster: 'b-toaster-top-center',
			solid: true,
		})
	}
}
